import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { SidePanel } from '@vertesia/ui/core';
// import { FullHeightLayout } from './FullHeightLayout.js'
import { Navbar } from './Navbar.js';
import { Sidebar } from './Sidebar.js';
import { SidebarContext } from './SidebarContext.js';
export function AppLayout({ sidebarClassName, className, title, children, logo, navbar, sidebar, mainNav }) {
    if (localStorage.getItem('desktopSidebarOpen') === null) {
        localStorage.setItem('desktopSidebarOpen', 'true');
    }
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [desktopSidebarOpen, setDesktopSidebarOpen] = useState(localStorage.getItem('desktopSidebarOpen') === 'true');
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024);
    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 1024);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const sidebarContextValue = {
        isOpen: isLargeScreen ? desktopSidebarOpen : sidebarOpen,
        toggleDesktop: (value) => {
            if (value === undefined) {
                setDesktopSidebarOpen(!desktopSidebarOpen);
            }
            else {
                setDesktopSidebarOpen(value);
            }
            localStorage.setItem('desktopSidebarOpen', JSON.stringify(!desktopSidebarOpen));
        },
        toggleMobile: (value) => {
            if (value === undefined) {
                setSidebarOpen(!sidebarOpen);
            }
            else {
                setSidebarOpen(value);
            }
        },
    };
    return (_jsx(_Fragment, { children: _jsx("div", { className: 'flex flex-col h-screen overflow-y-hidden', children: _jsxs(SidebarContext.Provider, { value: sidebarContextValue, children: [_jsx("div", { className: 'w-full', children: mainNav }), _jsxs("div", { className: 'flex h-full overflow-y-auto w-full', children: [_jsx("div", { className: "lg:hidden", children: _jsx(SidePanel, { className: 'bg-sidebar', isOpen: sidebarOpen, onClose: () => setSidebarOpen(false), side: "left", panelWidth: 288, resizable: false, backdrop: true, children: _jsx(Sidebar, { logo: logo, className: sidebarClassName, children: sidebar }) }) }), _jsx("div", { className: `hidden lg:block relative transition-all duration-300 ${desktopSidebarOpen ? 'w-72' : 'w-12'}`, children: _jsx(Sidebar, { logo: logo, className: sidebarClassName, children: sidebar }) }), _jsxs("div", { className: "w-full h-full overflow-y-hidden", children: [navbar ? (_jsx(Navbar, { title: title, logo: logo, children: navbar })) : null, _jsx("main", { className: clsx("flex-1 h-full w-full relative flex flex-col", className), children: children })] })] })] }) }) }));
}
//# sourceMappingURL=AppLayout.js.map